export default {
    m4a: 'audio/m4a',
    mp3: 'audio/mpeg',
    opus: 'audio/ogg; codecs=opus',
    vorbis: 'audio/ogg; codecs=vorbis',
    wav: 'audio/x-wav',
    weba: 'audio/webm'
};
